"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _step = _interopRequireDefault(require("./step.c"));

var _default =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(_default, _React$Component);

  function _default(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, _default);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(_default).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "stepStates", {
      INTERACTIVE: 'interactive',
      PASSED: 'passed'
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createRef", function (el) {
      var elementRef = _this.props.elementRef;

      if (typeof elementRef === 'function') {
        elementRef(el);
      } else if ((0, _typeof2["default"])(elementRef) === 'object') {
        elementRef.current = el;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toStep",
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(id) {
        var _this$props, children, onChange, list, nextStep;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, children = _this$props.children, onChange = _this$props.onChange;

                if (!(id && children && children.length)) {
                  _context.next = 12;
                  break;
                }

                list = _react["default"].Children.toArray(children), nextStep = list.find(function (child) {
                  return (child && child.props.id) === id;
                });

                if (!nextStep) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return new Promise(function (resolve) {
                  _this.setState({
                    step: id
                  }, function () {
                    return resolve();
                  });
                });

              case 6:
                if (typeof onChange === 'function') {
                  onChange(id, list.indexOf(nextStep));
                }

                _context.next = 10;
                break;

              case 9:
                throw new Error('StepController call .toStep without children or invalid step ID');

              case 10:
                _context.next = 13;
                break;

              case 12:
                throw new Error('StepController call .toStep without children or invalid step ID');

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getStep", function (id) {
      return _this.crefs[id] || null;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getModel", function (id) {
      var result = null;

      if (_this.crefs[id] && typeof _this.crefs[id].getModel === 'function') {
        result = _this.crefs[id].getModel();
      }

      return result;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getActiveStep", function () {
      return _this.crefs[_this.state.step] || null;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toNextStep",
    /*#__PURE__*/
    (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee2() {
      var step, children, list, current, currentIndex, rest, nextStep;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              step = _this.state.step, children = _this.props.children;

              if (!(step && children && children.length)) {
                _context2.next = 6;
                break;
              }

              list = _react["default"].Children.toArray(children), current = list.find(function (child) {
                return step === (child && child.props.id);
              }), currentIndex = list.indexOf(current), rest = list.slice(currentIndex + 1), nextStep = rest.find(function (child) {
                return child && !!child.props.id;
              });

              if (!nextStep) {
                _context2.next = 6;
                break;
              }

              _context2.next = 6;
              return _this.toStep(nextStep.props.id);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toPrevStep",
    /*#__PURE__*/
    (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee3() {
      var step, children, list, current, currentIndex, prev, prevStep;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              step = _this.state.step, children = _this.props.children;

              if (!(step && children && children.length)) {
                _context3.next = 6;
                break;
              }

              list = _react["default"].Children.toArray(children), current = list.find(function (child) {
                return step === (child && child.props.id);
              }), currentIndex = list.indexOf(current), prev = list.slice(0, currentIndex).reverse(), prevStep = prev.find(function (child) {
                return child && !!child.props.id;
              });

              if (!prevStep) {
                _context3.next = 6;
                break;
              }

              _context3.next = 6;
              return _this.toStep(prevStep.props.id);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_stepRef", function (id) {
      _this._stepRefs[id] = _this._stepRefs[id] || function (el) {
        return _this.crefs[id] = el;
      };

      return _this._stepRefs[id];
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isStepExist", function (id) {
      return !!_this._getChild(id);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getFirstAvailableStep", function () {
      var children = _this.props.children;
      var result = null;

      if (children) {
        var list = _react["default"].Children.toArray(children),
            nextStep = list.find(function (child) {
          return !!child.props.id;
        });

        if (nextStep) {
          result = nextStep.props.id;
        }
      }

      return result;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getActiveStepIndex", function () {
      var children = _this.props.children;
      var result = 0;

      if (children) {
        var list = _react["default"].Children.toArray(children).map(function (item) {
          return item.props.id;
        });

        result = list.indexOf(_this.state.step);
      }

      return result;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getChild", function (id) {
      var children = _this.props.children,
          list = children ? _react["default"].Children.toArray(children) : [];
      var result = null;

      if (list && list.length) {
        result = list.find(function (child) {
          return (child && child.props.id) === id;
        });
      }

      return result;
    });
    _this.state = {
      step: props.defaultStep || props.step || _this._getFirstAvailableStep()
    };

    _this.createRef((0, _assertThisInitialized2["default"])(_this));

    _this.crefs = {};
    _this._stepRefs = {};
    return _this;
  }

  (0, _createClass2["default"])(_default, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var step = this.props.step;

      if (step !== prevProps.step) {
        var nextStep;

        if (this._isStepExist(step)) {
          nextStep = step;
        } else {
          nextStep = this._getFirstAvailableStep();
        }

        if (nextStep !== this.state.step) {
          this.setState({
            step: nextStep
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.createRef(null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var proto = Object.getPrototypeOf(this),
          activeStepIndex = this._getActiveStepIndex();

      if (!this.props.children) {
        if (process && process.env.NODE_ENV !== 'production') {
          window.console.error("Creating StepController without steps in component ".concat(proto.constructor.displayName));
        }
      }

      var state = this.stepStates.PASSED,
          allVisibleStepsProcessed = false;
      return _react["default"].Children.map(this.props.children, function (child) {
        if (!child || allVisibleStepsProcessed) {
          return null;
        }

        var id = child.props.id;

        if (!id) {
          if (process && process.env.NODE_ENV !== 'production') {
            window.console.error("Step must contain \"id\" prop. ".concat(proto.constructor.displayName));
          }

          return null;
        }

        if (id === _this2.state.step) {
          state = _this2.stepStates.INTERACTIVE;
          allVisibleStepsProcessed = true;
        } // dont mount steps, that never been in INTERACTIVE state


        if (state !== _this2.stepStates.INTERACTIVE && !_this2.crefs[id]) {
          return null;
        }

        return _react["default"].createElement(_step["default"], {
          state: state,
          toNextStep: _this2.toNextStep,
          toPrevStep: _this2.toPrevStep,
          toStep: _this2.toStep,
          getModel: _this2.getModel,
          getActiveStep: _this2.getActiveStep,
          elementRef: _this2._stepRef(id),
          key: id,
          activeStepIndex: activeStepIndex
        }, child);
      });
    }
  }]);
  return _default;
}(_react["default"].Component);

exports["default"] = _default;
(0, _defineProperty2["default"])(_default, "propTypes", {
  onChange: _propTypes["default"].func,
  elementRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  step: _propTypes["default"].string,
  defaultStep: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].array])
});
(0, _defineProperty2["default"])(_default, "displayName", 'Base.Views.StepController');